type FlairManagerProps = {
  className?: string;
  width: number;
  height: number;
  ariaLabel: string;
};

const FlairManager = ({ className, width, height, ariaLabel }: FlairManagerProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 12 12"
    role="img"
    aria-label={ariaLabel}
  >
    <path
      fill="#926922"
      stroke="white"
      strokeWidth="1.5"
      paintOrder="stroke"
      filter="drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3))"
      d="M8.646 1a.66.66 0 0 1 .607.917l-.337.802h1.424c.394 0 .703.344.655.736C10.798 5.06 9.92 8.755 6 11 2.08 8.756 1.202 5.059 1.005 3.455a.658.658 0 0 1 .655-.736h1.424l-.337-.802A.66.66 0 0 1 3.354 1z"
    />
    <path
      stroke="#fff"
      d="M8.646 1a.66.66 0 0 1 .607.917l-.337.802h1.424c.394 0 .703.344.655.736C10.798 5.06 9.92 8.755 6 11 2.08 8.756 1.202 5.059 1.005 3.455a.658.658 0 0 1 .655-.736h1.424l-.337-.802A.66.66 0 0 1 3.354 1z"
    />
    <path
      fill="#fff"
      d="M6.352 2.938c-.11-.26-.212-.312-.349-.313-.137 0-.238.053-.349.313-.247.592-.802 1.001-1.324 1.386-.207.144-.276.403-.123.605.227.301.847.065 1.275-.368-.097.791-.803 1.39-1.37 1.757-.482.295-.057 1.04.443.774.206-.113.416-.24.62-.383.15-.104.354.007.354.189v1.645c0 .045.036.082.081.082h.784a.08.08 0 0 0 .082-.082V6.898c0-.182.204-.293.353-.189.204.142.414.27.62.383.5.266.926-.48.443-.774H7.89c-.567-.367-1.274-.967-1.37-1.76.429.434 1.05.68 1.274.384.133-.176.088-.474-.12-.618-.521-.385-1.077-.795-1.323-1.386"
    />
  </svg>
);

export default FlairManager;
